import { Moon, Shield, Sun } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

export function Header() {
  const { theme, toggleTheme } = useTheme();

  return (
    <header
      className="shadow-lg border-b-2 transition-colors duration-300"
      style={{ backgroundColor: 'var(--wcag-bg)', borderColor: 'var(--wcag-border)' }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Shield className="w-8 h-8" style={{ color: 'var(--wcag-primary)' }} />
            <h1 className="text-2xl font-bold" style={{ color: 'var(--wcag-text)' }}>
              Arnaqu'Quiz
            </h1>
          </div>

          <button
            onClick={toggleTheme}
            className="p-2 rounded-lg transition-colors duration-200 border-2"
            style={{ backgroundColor: 'var(--wcag-bg-alt)', borderColor: 'var(--wcag-border)' }}
            aria-label="Changer le thème"
          >
            {theme === 'light' ? (
              <Moon className="w-5 h-5" style={{ color: 'var(--wcag-text)' }} />
            ) : (
              <Sun className="w-5 h-5" style={{ color: 'var(--wcag-text)' }} />
            )}
          </button>
        </div>
      </div>
    </header>
  );
}
